import CloudDone from '@mui/icons-material/CloudDone';
import CloudOff from '@mui/icons-material/CloudOff';
import CloudSync from '@mui/icons-material/CloudSync';
import CloudUpload from '@mui/icons-material/CloudUpload';
import EventBusy from '@mui/icons-material/EventBusy';
import SyncProblem from '@mui/icons-material/SyncProblem';
import type { SxProps, Theme } from '@mui/material/styles';
import { palette } from '@openx/components-core/lib/theme/paletteV2.ts';

import { AudienceStatus } from '@openx/types/targeting/audience.ts';

const defaultStyles = {
  fontSize: '1rem',
  marginRight: 0.5,
  verticalAlign: 'middle',
};

const statusIcons = {
  [AudienceStatus.EXPIRED]: props => <EventBusy color={palette.warning.main} {...props} />,
  [AudienceStatus.EXPORTED]: props => <CloudDone color={palette.success.main} {...props} />,
  [AudienceStatus.EXPORTING]: props => <CloudSync color={palette.primary.main} {...props} />,
  [AudienceStatus.PUBLISHING]: props => <CloudUpload color={palette.action.disabled} {...props} />,
  [AudienceStatus.PUBLISH_FAILED]: props => (
    <CloudOff {...props} sx={{ color: palette.charts.tomato, ...(props.sx ?? {}) }} />
  ),
  [AudienceStatus.EXPORT_FAILED]: props => <SyncProblem color={palette.error.main} {...props} />,
};

export const StatusIcon = ({ status = '', sx }: { status?: string; sx?: SxProps<Theme> }) => {
  const IconComponent = statusIcons[status];

  if (!IconComponent) {
    return null;
  }

  return <IconComponent data-test={`status-${status.replace('_', '-')}`} sx={{ ...sx, ...defaultStyles }} />;
};
